import User from '@/store/user';
import CashRegisters from '@/store/cashRegisters';
export class RootStores {
  user = new User(this);
  cashRegisters = new CashRegisters(this);
}

export default new RootStores();
